
const digest = 'bb90d4aec146b7855311539ce871f8afec96413fa09929516bc331290084860c';
const classes = {"wrapper":"_wrapper_87fxq_1"};
const css = `._wrapper_87fxq_1 {
  height: calc(100vh - 85px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  